// extracted by mini-css-extract-plugin
module.exports = {"button":"_1CJMGL--style-module--button","shine-in-out":"_2Xspfs--style-module--shine-in-out"};